import React, { useState, useEffect, useCallback } from "react";
import { Col, Modal } from "react-bootstrap";
import ClosureReturnSection from "./ClosureReturnSection";
import ItemService from "../../../../services/customer_appCommonService";

const ReturnProcessModel = ({
  show,
  onHide,
  documentNumber,
  isExtension,
}) => {
  const [erfData, setErfData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchFullErfData = useCallback(async () => {
    if (!documentNumber) return;
    setLoading(true);
    try {
      const response = await ItemService.generateQuery({
        queryName: isExtension ? "ERFExtDetail" : "ERFDetail",
        documentNumber,
        timeZone: "Asia/Calcutta",
      });
      if (
        response?.status === 200 &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        setErfData(response.data[0]);
      } else {
        setErfData(null);
      }
    } catch (err) {
      console.error("ReturnProcessModel: failed to fetch ERF detail", err);
      setErfData(null);
    } finally {
      setLoading(false);
    }
  }, [documentNumber, isExtension]);

  // Fetch fresh data every time modal opens
  useEffect(() => {
    if (show && documentNumber) {
      fetchFullErfData();
    }
    // Clear on close so next open always starts fresh
    if (!show) {
      setErfData(null);
    }
  }, [show, documentNumber, fetchFullErfData]);

  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Closure Return — {documentNumber}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "0" }}>
        <div style={{ padding: "16px" }}>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Loading ERF data...</p>
            </div>
          ) : erfData ? (
            <ClosureReturnSection
              erfData={erfData}
              documentNumber={documentNumber}
              isExtension={isExtension}
              onRefresh={fetchFullErfData}
            />
          ) : (
            !loading && (
              <div className="text-center py-4 text-muted">
                <i className="bi bi-exclamation-circle me-2"></i>
                No data available for this document
              </div>
            )
          )}
        </div>
      </Modal.Body>

      <Modal.Footer style={{ padding: "10px 16px" }}>
        <Col xs={12} md={4} lg={4} className="headerButtonAlign">
          <Col xs={4} md={3} lg={3} className="d-flex justify-content-between">
            <button className="btnTable btn-danger" onClick={onHide}>
              Close
            </button>
          </Col>
        </Col>
      </Modal.Footer>
    </Modal>
  );
};

export default ReturnProcessModel;